import { render, staticRenderFns } from "./ReferenceImages.vue?vue&type=template&id=0184fb10&scoped=true&"
import script from "./ReferenceImages.vue?vue&type=script&lang=ts&"
export * from "./ReferenceImages.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceImages.vue?vue&type=style&index=0&id=0184fb10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0184fb10",
  null
  
)

export default component.exports